import { render, staticRenderFns } from "./despesasValueMobile.vue?vue&type=template&id=2f03eea3&scoped=true&"
import script from "./despesasValueMobile.vue?vue&type=script&lang=js&"
export * from "./despesasValueMobile.vue?vue&type=script&lang=js&"
import style0 from "./despesasValueMobile.vue?vue&type=style&index=0&id=2f03eea3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f03eea3",
  null
  
)

export default component.exports